import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import PesquisaService from '../../../services/pesquisa';
import '../../../styles/pesquisa.scss';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceFrown, faFaceFrownOpen, faFaceMeh, faFaceSmile, faFaceLaughBeam } from '@fortawesome/free-solid-svg-icons'


const Ouvidoria = () => {
    const [email, setEmail] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [responses, setResponses] = useState({});
    const questions = [
        {
            pergunta: "Como você avalia a atual Gestão Administrativa do nosso Município?",
            orgao: "Administração"
        },
        {
            pergunta: "Como você avalia o atendimento da Ouvidoria Geral do nosso Município?",
            orgao: "Ouvidoria"
        },
        {
            pergunta: "Qual seu nível de satisfação com a transparência no nosso município?",
            orgao: "Transparência"
        },
        {
            pergunta: "Como você avalia o serviço de coleta de lixo em seu bairro/município?",
            orgao: "Coleta de lixo"
        },
        {
            pergunta: "Como você avalia o serviço de conservação de limpeza das ruas em seu bairro/município?",
            orgao: "Conservação e limpeza das ruas"
        },
        {
            pergunta: "Como você avalia o estado de conservação das estradas viscinais de nosso município?",
            orgao: "Estradas viscinais"
        },
        {
            pergunta: "Como você avalia o serviço de conservação de praças, jardins e canteiros em seu bairro/município?",
            orgao: "Conservação de praças, jardins e canteiros"
        },
        {
            pergunta: "Como você avalia o empenho da gestão no fortalecimento da cultura e tradições em nosso município?",
            orgao: "Cultura"
        },
        {
            pergunta: "Como você avalia o serviço de iluminação pública de seu bairro/município?",
            orgao: "Iluminação pública"
        },
        {
            pergunta: "Como você avalia a questão de segurança pública em seu bairro/município?",
            orgao: "Segurança pública"
        },
        {
            pergunta: "Como você avalia a proteção e medidas ambientais em nosso município?",
            orgao: "Meio ambiente"
        },
        {
            pergunta: "Como você avalia o fortalecimento e investimento em práticas esportivas e lúdicas em seu bairro/município?",
            orgao: "Esporte e lazer"
        },
        {
            pergunta: "Como você avalia o atendimento e serviços da Saúde do nosso município?",
            orgao: "Saúde"
        },
        {
            pergunta: "Como você avalia o atendimento e serviços da Educação do nosso município?",
            orgao: "Educação"
        },
        {
            pergunta: "Como você avalia o atendimento e serviços da Assistência Social do nosso município?",
            orgao: "Assistência Social"
        },
        {
            pergunta: "Como você avalia a Secreteria Geral de Governo em nosso município?",
            orgao: "Governo e Gestão"
        },
        {
            pergunta: "Como você avalia o atendimento e serviços da Sala do Empreendedor em nosso município?",
            orgao: "Sala do Empreendedor"
        },
        {
            pergunta: "Como você avalia o atendimento e serviços do Departamento de Fiscalização, Tributos e Postura (DFTP) em nosso município?",
            orgao: "DFTP"
        },
        {
            pergunta: "Como você avalia o fomento ao turismo em nosso município?",
            orgao: "Turismo"
        },
        {
            pergunta: "Como você avalia o fomento ao trabalho e cursos profissionalizantes em nosso município?",
            orgao: "Trabalho"
        },
        {
            pergunta: "Como você avalia o acolhimento, tratamento e atividades para os idosos em nosso município?",
            orgao: "Envelhecimento saudável"
        },
        
    ];

    const notasPossiveis = [
        faFaceFrown,
        faFaceFrownOpen,
        faFaceMeh,
        faFaceSmile,
        faFaceLaughBeam
    ]

    const handleResponse = (orgao, nota) => {
        setResponses({ ...responses, [orgao]: nota });
    };

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const pesq = await PesquisaService.cadastro({
                mensagem: mensagem,
                email: email,
                avaliacao: Object.entries(responses).map(([orgao, nota]) => ({ orgao, nota }))
            })
            if (pesq.data["_id"]) {
                alert("Pesquisa registrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(pesq.data["error"]);
            }
        } catch (error) {
            console.log(error.response.data)
            alert(error.response.data.error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Row>
                    <h3 style={{ textAlign: 'center' }}>Avaliação contínua dos serviços públicos</h3>
                    <h6 style={{ textAlign: 'center' }}>Prezado cidadão, para melhor atender a sua demanda e aprimorar os serviços prestados por nossa gestão, gostaríamos que respondesse algumas perguntas para medir sua satisfação e, com isso, propor melhorias aos órgãos internos sobre os serviços avaliados.</h6>
                </Row>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Alert variant='secondary'>
                        <Row xs={2} lg={2}>

                            <Col xs={12} lg={3}>
                                <Form.Group className="mb-3" controlId="E-mail">
                                    <FloatingLabel
                                        label="E-mail"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={8}>
                                <p className='texto-p'>O e-mail é necessário para limitar a votação mensal por pessoa.<br />
                                    Os dados informados nesta pesquisa estarão seguros de acordo com a Lei Geral de Proteção de Dados - LGPD<br />
                                    O cidadão poderá votar, se desejar, todos os meses, caso haja mudança na qualidade do serviço prestado/oferecido. <br />
                                    Seu e-mail não será visível por nenhum responsável por receber as avaliações, mantendo assim seu anonimato.</p><br />
                                <Row xs={1} lg={5}>
                                    <Col>
                                        <p className='texto-pr'><FontAwesomeIcon className='opt opt-0' icon={faFaceFrown} /></p>
                                        <p className='texto-pr'>Muito insatisfeito</p>
                                    </Col>
                                    <Col>
                                        <p className='texto-pr'><FontAwesomeIcon className='opt opt-1' icon={faFaceFrownOpen} /></p>
                                        <p className='texto-pr'>Insatisfeito</p>

                                    </Col>
                                    <Col>
                                        <p className='texto-pr'><FontAwesomeIcon className='opt opt-2' icon={faFaceMeh} /></p>
                                        <p className='texto-pr'>Neutro</p>

                                    </Col>
                                    <Col>
                                        <p className='texto-pr'><FontAwesomeIcon className='opt opt-3' icon={faFaceSmile} /></p>
                                        <p className='texto-pr'>Satisfeito</p>
                                    </Col>
                                    <Col>
                                        <p className='texto-pr'><FontAwesomeIcon className='opt opt-4' icon={faFaceLaughBeam} /></p>
                                        <p className='texto-pr'>Muito satisfeito</p>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    </Alert>
                    <br /><br />
                    {questions.map((question, index) => (
                        <Fragment key={index} className="survey-question">
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={8}>
                                    <p>{question.pergunta}</p>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Row xs={5} lg={5}>
                                        {notasPossiveis.map((emoji, index) => (
                                            <Col>
                                                <FontAwesomeIcon onClick={() => handleResponse(question.orgao, index + 1)} className={`opt opt-${index} ${responses[question.orgao] === index + 1 ? 'selected' : ''}`} icon={emoji} />
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                            </Row>
                            <br />
                            <hr />
                            <br />
                        </Fragment>

                    ))}

                    <Row xs={1}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Descrição">
                                <FloatingLabel
                                    label="Mensagem (não obrigatório)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="mensagem"
                                        value={mensagem}
                                        onChange={e => setMensagem(e.target.value)}
                                        as="textarea"
                                        rows={5}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/ouvidoria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Sua pesquisa foi registrada com sucesso!</Alert>
                <br /><br />
                <br /><br />
                <Link to={'/pesquisa/resultados'}>
                    <Button variant="success" type="button">
                        Veja os resultados das pesquisas
                    </Button>
                </Link>
                <Link to={'/ouvidoria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Ouvidoria;